import { useOutletContext, useParams } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import RoleLegalEntitiesForm from 'modules/job_catalog/components/RoleLegalEntitiesForm'
import RoleLevelsForm from 'modules/job_catalog/components/RoleLevelsForm'
import RoleSupervisorsForm from 'modules/job_catalog/components/RoleSupervisorsForm'
import { type Role } from 'modules/job_catalog/hooks/useRole'

import { RoleBasicInfoForm } from './RoleBasicInfoForm'

interface OutletContext {
  role?: Role
  canEditRole: boolean
  isLoading: boolean
}

const Component = () => {
  const { role, isLoading, canEditRole } = useOutletContext<OutletContext>()
  const { id } = useParams<{ id: string }>()
  const roleId = Number(id)

  if (!role) {
    return null
  }

  return (
    <AuthorizeUser authorizeFn={() => canEditRole || isLoading}>
      <RoleBasicInfoForm role={role} />
      <RoleLegalEntitiesForm roleId={roleId} />
      <RoleLevelsForm roleId={roleId} contractVersions={contractVersions} />
      <RoleSupervisorsForm roleId={roleId} />
    </AuthorizeUser>
  )
}

export default Component
